import { createStorageSlice } from './slice';

export const RECONCILIATION_STATEMENT_STORAGE_DOMAIN = 'reconciliation-statements';

export const reconciliationStatementStorageSlice = createStorageSlice(RECONCILIATION_STATEMENT_STORAGE_DOMAIN);
